<div>
  <form [formGroup]="customerBusinessDetailAndUploadForm">
    <div class="gap-6 flex flex-col">
      <div class="w-full flex flex-col bg-white rounded-xl pb-6">
        <div
          class="flex w-full justify-between rounded-t-xl py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
        >
          <div class="flex gap-4">
            <div class="h-10 w-1 bg-primary"></div>
            <span>Business Details</span>
          </div>
          <div
            (click)="bussinessDetails = !bussinessDetails"
            class="p-1 rounded-full h-6 w-6 bg-gray-300"
          >
            <img src="../../../assets/image/Arrows.svg" />
          </div>
        </div>

        <div
          *ngIf="bussinessDetails"
          class="p-5 grid md:grid-cols-2 grid-col-1 gap-4"
        >
          <div class="flex-col flex gap-2">
            <span> Organisation Type *</span>
            <input *ngIf="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'" [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
            class="w-full border p-2 rounded-md outline-none"
            
            formControlName="organisationType"
            name="organisationType"
          />
            <select *ngIf="!((singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin')" [disabled]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
              class="w-full p-2 outline-none border rounded-md"
              formControlName="organisationType"
              name="organisationType"
            >
              <option value="" selected disabled>Select Organisation Type</option>
              <option value="private-limited-public-limited">Private limited/Public Limited</option>
              <option value="partnership">Partnership</option>
              <option value="limited-liability-partnership">Limited Liability Partnership (LLP)</option>
              <option value="trust-ngo">Trust NGO</option>
              <option value="society">Society</option>
              <option value="government-services-government-undertakings">
                Government Services / Government Undertakings
              </option>
              <option value="sole-proprietorship">
                Sole Proprietorship
              </option>
            </select>
            <div
              *ngIf="
                customerBusinessDetailAndUploadForm.controls['organisationType']
                  .touched &&
                !customerBusinessDetailAndUploadForm.controls[
                  'organisationType'
                ].valid
              "
              class="text-red-500"
            >
              Organisation Type Is Required
            </div>
          </div>
          <div class="flex-col flex gap-2">
            <span> Business Name *</span>
            <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
              class="w-full border p-2 rounded-md outline-none"
              placeholder="Enter Business Name"
              formControlName="businessName"
              name="businessName"
            />
            <div
              *ngIf="
                customerBusinessDetailAndUploadForm.controls['businessName']
                  .touched &&
                !customerBusinessDetailAndUploadForm.controls['businessName']
                  .valid
              "
              class="text-red-500"
            >
              Business Name Is Required
            </div>
          </div>

          <div class="flex-col flex gap-2">
            <span>Multicurrency Payments Required? *</span>
            <input *ngIf="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'" [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
            class="w-full border p-2 rounded-md outline-none"
            
            formControlName="multicurrencyPayments"
            name="multicurrencyPayments"
          />
            <select *ngIf="!((singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin')" [disabled]="(singleRole == 'merchant' || singleRole == 'reseller') && userRole == 'admin'"
              class="w-full p-2 outline-none border rounded-md"
              selectInput="Select "
              formControlName="multicurrencyPayments"
              name="multicurrencyPayments"
            >
              <option value="" disabled>Select</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
            <div
              *ngIf="
                customerBusinessDetailAndUploadForm.controls[
                  'multicurrencyPayments'
                ].touched &&
                !customerBusinessDetailAndUploadForm.controls[
                  'multicurrencyPayments'
                ].valid
              "
              class="text-red-500"
            >
              Select Multicurrency
            </div>
          </div>
          <div class="flex-col flex gap-2">
            <span> Website URL *</span>
            <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
              placeholder="Enter URL"
              class="w-full border p-2 rounded-md outline-none"
              formControlName="website"
              name="website"
            />

            <div
              *ngIf="customerBusinessDetailAndUploadForm.controls['website'].errors?.['pattern'] ||
              (customerBusinessDetailAndUploadForm.controls['website'].touched &&
              !customerBusinessDetailAndUploadForm.controls['website'].valid)"
              class="text-red-500"
            >
              Invalid Website Url
            </div>
          </div>
          <div class="flex-col flex gap-2">
            <span>Operation Address *</span>
            <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
              class="w-full border p-2 rounded-md outline-none"
              placeholder="Enter Operation Address"
              formControlName="address"
              name="address"
            />
            <div
              *ngIf="
                customerBusinessDetailAndUploadForm.controls['address']
                  .touched &&
                !customerBusinessDetailAndUploadForm.controls['address'].valid
              "
              class="text-red-500"
            >
              Address Is Required
            </div>
          </div>
          <div class="flex-col flex gap-2">
            <span> Business Service *</span>
            <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
              class="w-full border p-2 rounded-md outline-none"
              placeholder="Enter Business Service"
              formControlName="businessModel"
              name="businessModel"
            />
            <div
              *ngIf="
                customerBusinessDetailAndUploadForm.controls['businessModel']
                  .touched &&
                !customerBusinessDetailAndUploadForm.controls['businessModel']
                  .valid
              "
              class="text-red-500"
            >
              Business Service Is Required
            </div>
          </div>
          <div class="flex-col flex gap-2">
            <span> Operation Address State *</span>
            <!-- <input *ngIf="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'" [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
            class="w-full border p-2 rounded-md outline-none"
            
            formControlName="state"
            name="state"
          /> -->
            <select 
              (change)="onStateSelect($event)" [disabled]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
              formControlName="state"
              name="state"
              class="w-full border p-2 rounded-md outline-none"
            >

              <option value="" disabled>Select Operation Address State</option>
              <option *ngFor="let state of stateData" [value]="state?.stateId">
                {{ state?.title }}
              </option>
            </select>
            <div
              *ngIf="
                customerBusinessDetailAndUploadForm.controls['state'].touched &&
                !customerBusinessDetailAndUploadForm.controls['state'].valid
              "
              class="text-red-500"
            >
              State Is Required
            </div>
          </div>
          <div class="flex-col flex gap-2">
            <span>Operation Address City *</span>
            <!-- <input *ngIf="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'" [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
            class="w-full border p-2 rounded-md outline-none"
            value=""
            formControlName="city"
            name="city"
          /> -->
            <select [disabled]="!selectedState" 
              class="w-full p-2 outline-none border rounded-md"
              formControlName="city"
              name="city" 
              (change)="onCitySelect($event)"
            >
              <option value="" disabled>Select Operation Address City</option>
              <option *ngFor="let city of cityData" [value]="city?._id">
                {{ city?.title }}
              </option>
            </select>
            <div
              *ngIf="
                customerBusinessDetailAndUploadForm.controls['city'].touched &&
                !customerBusinessDetailAndUploadForm.controls['city'].valid
              "
              class="text-red-500"
            >
              City Is Required
            </div>
          </div>

          <div class="flex-col flex gap-2">
            <span> Date of Establishment *</span>
            <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
              type="date"
              class="w-full border p-2 rounded-md outline-none"
              placeholder="Enter Dtae of Establishment"
              formControlName="dateOfEstablishment"
              name="dateOfEstablishment"
              [max]="cValue"
            />
            <div
              *ngIf="
                customerBusinessDetailAndUploadForm.controls[
                  'dateOfEstablishment'
                ].touched &&
                !customerBusinessDetailAndUploadForm.controls[
                  'dateOfEstablishment'
                ].valid
              "
              class="text-red-500"
            >
              Date Of Establishment Is Required
            </div>
          </div>
          <div class="flex-col flex gap-2">
            <span>Operation Address Pincode *</span>
            <input maxlength="6" [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
              class="w-full border p-2 rounded-md outline-none"
              placeholder="Enter Address Pincode"
              formControlName="postalCode"
              name="postalCode"
            />
            <div
              *ngIf="
                customerBusinessDetailAndUploadForm.controls['postalCode']
                  .touched &&
                !customerBusinessDetailAndUploadForm.controls['postalCode']
                  .valid
              "
              class="text-red-500"
            >
              Pincode Is Required
            </div>
          </div>
          <div class="flex-col flex gap-2">
            <span> PAN *</span>
            <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
              placeholder="Enter Your PAN"
              class="w-full border p-2 rounded-md outline-none"
              formControlName="pancard"
              name="pancard"
            />
            <div
              *ngIf="customerBusinessDetailAndUploadForm.controls['pancard'].errors?.['pattern'] ||
            (customerBusinessDetailAndUploadForm.controls['pancard'].touched &&
            !customerBusinessDetailAndUploadForm.controls['pancard'].valid)"
              class="text-red-500"
            >
              Invalid PAN Number
            </div>
          </div>
          <div class="flex-col flex gap-2">
            <span> CIN </span>
            <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
              class="w-full border p-2 rounded-md outline-none"
              placeholder="Enter CIN"
              formControlName="cinNo"
              name="cinNo"
            />
            <div
              *ngIf="customerBusinessDetailAndUploadForm.controls['cinNo'].errors?.['pattern'] ||
            (customerBusinessDetailAndUploadForm.controls['cinNo'].touched &&
            !customerBusinessDetailAndUploadForm.controls['cinNo'].valid)"
              class="text-red-500"
            >
              Invalid CIN Number
            </div>
          </div>
          <div class="flex-col flex gap-2">
            <span>Expected Number of Transactions *</span>
            <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
              class="w-full border p-2 rounded-md outline-none"
              placeholder="Enter Number of Transactions"
              formControlName="transactionsNo"
              name="transactionsNo"
              (keypress)="keyPressNumbers($event)"
            />
            <div
              *ngIf="
                customerBusinessDetailAndUploadForm.controls['transactionsNo']
                  .touched &&
                !customerBusinessDetailAndUploadForm.controls['transactionsNo']
                  .valid
              "
              class="text-red-500"
            >
              Transaction Number Is Required
            </div>
          </div>

          <div class="flex-col flex gap-2">
            <span> Name on PAN Card *</span>
            <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
              class="w-full border p-2 rounded-md outline-none"
              placeholder="Enter Name on PAN Card"
              formControlName="pancardName"
              name="pancardName"
            />
            <div
              *ngIf="
                customerBusinessDetailAndUploadForm.controls['pancardName']
                  .touched &&
                !customerBusinessDetailAndUploadForm.controls['pancardName']
                  .valid
              "
              class="text-red-500"
            >
              PAN Card Name Is Required
            </div>
          </div>
          <div class="flex-col flex gap-2">
            <span> Expected Amount of Transaction in (INR)*</span>
            <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
              placeholder="Enter Amount of Transaction"
              class="w-full border p-2 rounded-md outline-none"
              formControlName="transactionsAmount"
              name="transactionsAmount"
              (keypress)="keyPressNumbers($event)"
            />
            <div
              *ngIf="
                customerBusinessDetailAndUploadForm.controls[
                  'transactionsAmount'
                ].touched &&
                !customerBusinessDetailAndUploadForm.controls[
                  'transactionsAmount'
                ].valid
              "
              class="text-red-500"
            >
              Transaction Amount is required
            </div>
          </div>
          <div class="flex-col flex gap-2">
            <span> {{ roleOnboading }} GST Number *</span>
            <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
              class="w-full border p-2 rounded-md outline-none"
              placeholder="Enter {{ roleOnboading }} GST Number"
              formControlName="gstNo"
              name="gstNo"
            />

            <div
              *ngIf="
                customerBusinessDetailAndUploadForm.controls['gstNo'].touched &&
                (!customerBusinessDetailAndUploadForm.controls['gstNo'].valid ||
                  customerBusinessDetailAndUploadForm.controls[
                    'gstNo'
                  ]?.hasError('pattern'))
              "
              class="text-red-500"
            >
              Enter Valid GST Number
            </div>
          </div>
        </div>
      </div>
      <!-- Uplode -->
      <div class="w-full flex flex-col bg-white rounded-xl pb-6">
        <div
          class="flex w-full justify-between rounded-t-xl py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
        >
          <div class="flex gap-4">
            <div class="h-10 w-1 bg-primary"></div>
            <span>Uploaded Documents</span>
          </div>
          <div class="p-1 rounded-full h-6 w-6 bg-gray-300">
            <img src="../../../assets/image/Arrows.svg" />
          </div>
        </div>

        <div class="p-5 flex-col gap-6 flex">
          <div class="flex gap-6">
            <!-- <button
              class="bg-primary w-40 flex items-center justify-center text-white text-center rounded-2xl mx-3 cursor-pointer"
            >
              Upload
              <input
                type="file"
                style="opacity: 0"
                multiple
                (change)="onFileSelected($event)"
              />
            </button> -->
            <span class="text-gray-400"
              >File should be image and less than 20 mb (PDF, JPEG, JPG)</span
            >
          </div>

          <div class="gap-6 grid md:grid-cols-2 grid-cols-1 lg:grid-cols-4">
            <div
              *ngFor="let i of documents; let imgIndex = index"
              class="shadow-xl border p-4 rounded-xl gap-4 flex flex-col"
            >
              <div class="p-2">{{ i.documentName }}</div>
              <div class="border border-primary h-full w-full rounded-xl">
                <div
                  class="text-white bg-primary text-left items-center w-full p-2 rounded-t-xl flex justify-between"
                >
                  <div>{{ i.heading }}</div>
                  <!-- <img [src]="i.file" alt="preview Image" /> -->
                </div>
                <div class="h-45">
                  <img
                    *ngIf="i?.file"
                    [src]="i.file"
                    alt="{{ i?.file }}"
                    class="h-40"
                  />
                  <div class="w-full flex items-center justify-center p-2">
                    <button
                      class="p-2 px-4 bg-primary text-white rounded-xl"
                      *ngIf="i?.file"
                      (click)="downloadFile(i?.file)"
                    >
                      download
                    </button>
                  </div>
                  {{ i?.name ? i?.name : "" }}
                </div>
              </div>
              <button   [disabled]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
                (click)="fileUplode.click()"
                class="bg-primary cursor-pointer px-8 p-2 flex items-center relative justify-center text-white text-center rounded-2xl w-full"
              >
                Upload
                <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
                  #fileUplode
                  type="file"
                  accept="image/jpg, image/jpeg, application/pdf"
                  style="opacity: 0"
                  (change)="onFileSelected($event, i?.type)"
                  placeholder=""
                  class="absolute inset-0 cursor-pointer w-full hidden"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Scheme Manager -->
      <!-- <div class="w-full flex flex-col bg-white rounded-xl pb-6">
        <div
          class="flex w-full justify-between rounded-t-xl py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
        >
          <div class="flex gap-4">
            <div class="h-10 w-1 bg-primary"></div>
            <span>Scheme Manager</span>
          </div>
          <div class="p-1 rounded-full h-6 w-6 bg-gray-300">
            <img src="../../../assets/image/Arrows.svg" />
          </div>
        </div>
        <div class="p-5 gap-2 flex flex-col w-1/2">
          <span> Scheme</span>
          <select
            class="w-full p-2 outline-none border rounded-md"
            formControlName="SchemeManager"
            name="SchemeManager"
          >
            <option *ngFor="let scheme of schemes">{{scheme.schemeName}}</option>
          </select>
        </div>
      </div> -->

      <!--  -->
    </div>
  </form>
</div>
